/* eslint-disable no-unused-vars */
import {
  QuestionFormFieldWithOptions,
  QuestionFormFieldWithOptionsType,
} from './questionFormFieldWithOptions'

/**
 * Creates an instance of SelectField.
 * @typedef {Object} SelectFieldType
 *
 * @typedef {QuestionFormFieldWithOptionsType & SelectFieldType} SelectFieldExtendType
 */

/**
 * Represents a select form field.
 * @class
 */
export class SelectField extends QuestionFormFieldWithOptions {}
